<template>
    <teleport to="head">
        <meta name="title" content="404"/>
        <meta name="robots" content="noindex"/>
    </teleport>
    <div style="text-align: center;">
        <h1>404: It seems you're lost</h1>
        <div><img id="you_are_lost" src="https://i.giphy.com/2t9mb0HwTVn3mHj8AZ.gif"></div>
        <h2>Let's get you <router-link to="/">home</router-link></h2>
    </div>
</template>

<script>
    export default {
        name: "",
        components: {

        },
        data () {
            return {

            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style scoped>
    #you_are_lost {
        width: 100%;
        max-width: 700px;
    }
</style>